import api from './api';
import { Article, ArticleList, TreatmentCategory, WhatsHotResponse } from '../types/article';

export const articlesApi = {
  // Get What's Hot page data
  getWhatsHot: async (): Promise<WhatsHotResponse> => {
    const response = await api.get('/api/articles/whats-hot');
    return response.data;
  },

  // Get articles by treatment category
  getArticlesByTreatmentCategory: async (
    category: TreatmentCategory,
    skip = 0,
    limit = 100
  ): Promise<ArticleList[]> => {
    const response = await api.get(`/api/articles/treatment-category/${category}`, {
      params: { skip, limit },
    });
    return response.data;
  },

  // Get popular articles
  getPopularArticles: async (days = 30, limit = 10): Promise<ArticleList[]> => {
    const response = await api.get('/api/articles/popular', {
      params: { days, limit },
    });
    return response.data;
  },

  // Get recent articles
  getRecentArticles: async (skip = 0, limit = 100): Promise<ArticleList[]> => {
    const response = await api.get('/api/articles/', {
      params: { skip, limit },
    });
    return response.data;
  },

  // Get article by ID
  getArticle: async (id: number): Promise<Article> => {
    const response = await api.get(`/api/articles/${id}`);
    return response.data;
  },

  // Get article by slug
  getArticleBySlug: async (slug: string): Promise<Article> => {
    const response = await api.get(`/api/articles/slug/${slug}`);
    return response.data;
  },

  // Search articles
  searchArticles: async (query: string, skip = 0, limit = 100): Promise<ArticleList[]> => {
    const response = await api.get('/api/articles/search', {
      params: { q: query, skip, limit },
    });
    return response.data;
  },

  // Get related articles
  getRelatedArticles: async (articleId: number, limit = 5): Promise<ArticleList[]> => {
    const response = await api.get(`/api/articles/${articleId}/related`, {
      params: { limit },
    });
    return response.data;
  },
};
